export const companys = require('./company')